module.exports = require("jsonwebtoken");


//////////////////
// WEBPACK FOOTER
// external "jsonwebtoken"
// module id = 8
// module chunks = 0